import { Box, IconButton, Stack, styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { ContextMenuItem } from '$comp/_app/components/chat/components/body/components/context-menu/components'
import { ArrowRightIcon, CopyIcon } from '$common/icons'
import { ShareIcon } from '$common/icons/share'
import { IconCover } from '$common/icon-cover/icon-cover'
import { ShareOutlineIcon } from '$common/icons/share-outline'
import { t } from '$i18n'

const Root = styled(Stack)`
  padding: 20px 10px 5px;
`

const StyledBox = styled(Box)`
  margin-left: 10px;
`

export interface Props {
  canForward: boolean
  onShare: () => unknown
  onForward: () => unknown
  onCopyLink: () => unknown
  isOpen?: boolean
}
export function ShareWappModal({
  canForward,
  onShare,
  onForward,
  onCopyLink,
  isOpen,
}: Props) {
  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <Root>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-start',
            marginBottom: '20px',
            alignItems: 'center',
            marginRight: '5px',
          }}
          gap="5px"
        >
          <IconButton
            onClick={closeCurrentModal}
            sx={{ width: '24px', height: '24px' }}
          >
            <ArrowRightIcon color="primary" />
          </IconButton>
          <Typography variant="subtitle1" color="primary">
            {t('menu.common.share')}
          </Typography>
        </Box>
        <Stack gap="8px">
          {canForward && (
            <ContextMenuItem
              onClick={async () => {
                await closeCurrentModal()
                onForward()
              }}
              text={t('shareWappModal.shareInSahab')}
            >
              <StyledBox>
                <IconCover>
                  <ShareOutlineIcon
                    sx={{
                      color: 'secondary.main',
                      width: '20px',
                      height: '20px',
                    }}
                  />
                </IconCover>
              </StyledBox>
            </ContextMenuItem>
          )}
          {onShare && (
            <ContextMenuItem
              onClick={async () => {
                await closeCurrentModal()
                onShare()
              }}
              text={t('shareWappModal.shareOutOfSahab')}
            >
              <StyledBox>
                <IconCover>
                  <ShareIcon
                    sx={{
                      color: 'secondary.main',
                      width: '20px',
                      height: '20px',
                    }}
                  />
                </IconCover>
              </StyledBox>
            </ContextMenuItem>
          )}
          <ContextMenuItem onClick={onCopyLink} text={t('shareWappModal.copy')}>
            <StyledBox>
              <IconCover>
                <CopyIcon
                  sx={{
                    color: 'secondary.main',
                    width: '20px',
                    height: '20px',
                  }}
                />
              </IconCover>
            </StyledBox>
          </ContextMenuItem>
        </Stack>
      </Root>
    </BottomDrawer>
  )
}

ShareWappModal.defaultProps = {
  isOpen: false,
}
